<app-mb-modal
  [isVisible]="isVisible"
  [title]="'Edit Staff Member'"
  [okText]="'Update Staff'"
  (isVisibleChange)="isVisibleChange.emit($event)"
  (OkActionHandler)="handleEditStaffSubmit()"
>
  <app-edit-staff-form
    #editStaffForm
    [staffData]="staffData"
    [organizationId]="organizationId"
  />
</app-mb-modal>


<app-mb-success-modal
  [(isVisible)]="isSuccessModalVisible"
  [message]="successMessage"
  (isVisibleChange)="closeSuccessModal()"
/>
